import React from 'react'
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Layoutcreatepage from "../../../components/common/Form/Create-Layout";
import { usePostFoodItemMutation} from '../../../store/api/meals';

function AddFoodItem() {
const navigate = useNavigate();
const[createFoodItem] = usePostFoodItemMutation()
const [loading, setLoading] = useState(false);
const [feedbackMessage, setFeedbackMessage] = useState({
    type: "",
    message: "",
  });


  const fields = [
    {
      name: "name",
      label: "Fooditem",
      type: "text",
      placeholder: "Enter Food Item Name",
      required:true
    },
    {
        name: "calories",
        label: "Calories",
        type: "number",
        placeholder: "Enter calories",
        required:true
      },
      {
        name: "protein",
        label: "Protein",
        type: "number",
        placeholder: "Enter protein",
        required:true
      },
      {
        name: "carbs",
        label: "carbs",
        type: "number",
        placeholder: "Enter carbs",
        required:true
      },
      {
        name: "fats",
        label: "Fats",
        type: "number",
        placeholder: "Enter Fats",
        required:true
      },
  ];

  const initialValues = {
    branch_name: "",
    name: "",
    calories: "",
    protein: "",
    carbs: "",
    fats: "",
  };
  const onSubmit = async (values, { setSubmitting }) => {
    try {

      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => {
          formData.append(key, value);
      });
      const response = await createFoodItem(formData);
      
      setLoading(true);
      if(response.error){
        setFeedbackMessage({
          type: "error",
          message: response?.error?.data?.error,
          });
      }else{
        if (response.data) {
          setFeedbackMessage({
            type: "success",
            message: "Fooditem Created successfully!",
          });
          
          setTimeout(() => {
            navigate("/mealitem-list", { state: { pageName: "Food Item" } });
          }, 2000);
        } 
      }
      
    } catch (error) {
     
      setFeedbackMessage({
        type: "error",
        message: error?.message || "Something went wrong.",
      });
    } finally {
      setSubmitting(false);
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/mealitem-list",{ state: { pageName: "Food Item" } });
  };
  const validationSchema = Yup.object({
    name: Yup.string().required("Food item name is required"),
    calories: Yup.number()
      .typeError("Calories must be a number")
      .positive("Calories must be a positive number")
      .required("Calories are required"),
    protein: Yup.number()
      .typeError("Protein must be a number")
      .positive("Protein must be a positive number")
      .required("Protein is required"),
    carbs: Yup.number()
      .typeError("Carbs must be a number")
      .positive("Carbs must be a positive number")
      .required("Carbs are required"),
    fats: Yup.number()
      .typeError("Fats must be a number")
      .positive("Fats must be a positive number")
      .required("Fats are required"),
  });

  return (
    <div className="pb-4 pt-3 ">
        <Layoutcreatepage
        title="Add Fooditem"
        fields={fields}
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={onSubmit}
        buttonText="Add Fooditem"
        navigateTo="/mealitem-list"
        loading={loading}
        feedbackMessage={feedbackMessage}
        onCancel={handleCancel} 
      />

    </div>
  )
}

export default AddFoodItem

